import { Component, WritableSignal, signal } from '@angular/core'

import { ICellRendererAngularComp } from 'ag-grid-angular'
import { ICellRendererParams } from 'ag-grid-community'
import { TagModule } from 'primeng/tag'
import { TooltipModule } from 'primeng/tooltip'

import { processStatusTagTypeMap } from '@flowx/designer/modules/core/dictionary/common.types'

@Component({
  imports: [TooltipModule, TagModule],
  template: `<p-tag
    [value]="state()"
    [severity]="processStatusTagTypeMap[state()] || 'info'"
    [attr.data-testId]="testId()"
    class="flx-tag"
  />`,
})
export class FlxInstanceStatusComponent implements ICellRendererAngularComp {
  state: WritableSignal<string> = signal<string>(null)
  testId = signal<string | null>('')
  processStatusTagTypeMap = processStatusTagTypeMap
  agInit(params: ICellRendererParams<any, any, any>): void {
    this.state.set(params.value)
    this.testId.set(`table-cell-${params.column.getColId()}`)
  }
  refresh(params: ICellRendererParams<any, any, any>): boolean {
    this.state.set(params.value)
    this.testId.set(`table-cell-${params.column.getColId()}`)
    return true
  }
}
